import React from 'react';
import './Header.css';

const Header = () => {
    return (
        <>
        <nav className="menu-bar">
            <div className="menu-list">
                <h2><span style={{fontWeight:'600',color:'rgb(150, 137, 137)', fontSize:"50px"}}>𝐼𝒥</span><span style={{color:"rgb(45, 76, 78)"}}> 𝒮𝒜𝒯𝐻𝐼</span></h2>
            </div>
            <div className="resume">
            <a target="_blank" rel="noreferrer" className="log-in" href="https://drive.google.com/file/d/1zn-w0QiKUCC_sWQL8tsNR3XIefa1ezQ1/view">DOWNLOAD RESUME</a>
            </div>
        </nav>
        </>
    );
};

export default Header;